var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-panel"},[(_vm.$store.state.chinaMap.currentlyMapAdcode)?_c('BarChart',{staticStyle:{"height":"50%"}}):_vm._e(),_c('TotalQuantity',{staticStyle:{"height":"50%"}}),( _vm.$store.state.chinaMap.dataType == 3)?_c('serviceRanking',{staticStyle:{"height":"50%"}}):_vm._e(),(
      !_vm.$store.state.chinaMap.currentlyMapAdcode &&
      _vm.$store.state.chinaMap.dataType !== 3
    )?_c('priceTrend',{staticStyle:{"height":"50%"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }